import {Attributes, Currency, CustomConfig, BaseProduct} from './types';

export const isCustom = (attributes: Attributes) => attributes.bundleMode === 'custom' ||
    (attributes.bundleMode !== 'catalog' && !attributes.steps.some(step => step.productIds?.length));

export const choiceId = () => globalThis.crypto?.randomUUID?.() || `choice-${Date.now()}-${Math.random().toString(36).slice(2)}`;

export const minorPrice = (value: string, decimals: number): number | null => {
    if (!/^\d+(?:\.\d+)?$/.test(value.trim())) return null;
    const price = Number(value);
    return Number.isFinite(price) && price <= 1000000 ? Math.round(price * 10 ** decimals) : null;
};

export const previewConfig = (attributes: Attributes, currency: Currency, product?: BaseProduct): CustomConfig => ({
    mode: 'custom', bundleName: attributes.bundleName || 'Custom bundle',
    basePrice: minorPrice(attributes.basePrice || '0', currency.decimals) ?? 0,
    steps: attributes.steps.map((step, index) => ({
        id: `step-${index}`, title: step.title, description: step.description, required: step.required,
        choices: (step.choices || []).map(choice => ({
            id: choice.id, label: choice.label, description: choice.description,
            price: minorPrice(choice.price, currency.decimals) ?? 0,
            image: choice.imageUrl, enabled: !!choice.label.trim() && choice.enabled !== false,
        })),
    })),
    allowQuantity: attributes.allowQuantity, summaryTitle: attributes.summaryTitle, buttonText: attributes.buttonText,
    currency, displayFactor: product?.displayFactor ?? 1, available: true, maxQuantity: product?.maxQuantity ?? 20,
});

export const customSelection = (config: CustomConfig, selections: Record<string, string>, quantity: number) => {
    const rows = config.steps.map(step => ({step, choice: step.choices.find(choice => choice.id === selections[step.id] && choice.enabled)}));
    const validQuantity = Number.isInteger(quantity) && quantity >= 1 && quantity <= config.maxQuantity && (config.allowQuantity || quantity === 1);
    const complete = rows.some(row => row.choice) && rows.every(({step, choice}) => choice || (!step.required && !selections[step.id]));
    const unitPrice = config.basePrice + rows.reduce((sum, row) => sum + (row.choice?.price || 0), 0);
    return {rows, ready: !!(config.available && validQuantity && complete), unitPrice,
        total: Math.round(unitPrice * config.displayFactor * (validQuantity ? quantity : 1))};
};
